// 色はセル・凡例・内訳・取得方法列が共有する。列定義とセルの相互 import を避けるため単独で置く
/**
 * 凡例と同じ色をセルにも使うため、色は1か所で持つ。
 * アンバー×藍は色覚多様性に配慮した配色（Okabe–Ito）を基にし、新規取得＝これから費用のかかる取得を促す暖色、
 * リユース＝安く取れる候補の寒色として意味を分ける。
 * アンバーは小さな文字にも使うため、白地で 4.5:1 を満たす明度まで落としている（元の #e69f00 は 2.3:1）
 */
export const BULK_MARK_COLORS = {
  unacquiredLine: "#a56a00",
  reusableLine: "#0072b2",
} as const;
